import { render, staticRenderFns } from "./StorybookTemplate.vue?vue&type=template&id=dbce315c"
import script from "./StorybookTemplate.vue?vue&type=script&lang=js"
export * from "./StorybookTemplate.vue?vue&type=script&lang=js"
import style0 from "./StorybookTemplate.vue?vue&type=style&index=0&id=dbce315c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports